import { ButtonIcon } from "../../Components/MenuIcons/styles";

export const LogoutIcon = (props: { onClick: () => void }) => {
  return (
    <ButtonIcon onClick={props.onClick}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 140 140"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path
            d="M124.62 73.6196H63.0571C60.4077 73.6196 58.2598 71.9984 58.2598 69.9989C58.2598 67.9982 60.4077 66.377 63.0571 66.377H124.617L104.512 49.1675C102.765 47.675 102.949 45.3952 104.925 44.0759C106.902 42.7554 109.922 42.8944 111.67 44.3869L138.802 67.6097C140.425 68.9951 140.383 71.0607 138.785 72.4063L111.669 95.612C109.922 97.1056 106.901 97.2446 104.923 95.923C102.948 94.6037 102.763 92.3228 104.51 90.8302L124.62 73.6196ZM107.991 113.51C107.991 111.509 110.16 109.888 112.835 109.888C115.512 109.888 117.681 111.509 117.681 113.51V129.736C117.681 132.556 116.131 135.124 113.645 136.982C111.155 138.841 107.719 139.999 103.949 139.999H13.7334C9.96047 139.999 6.52294 138.844 4.03358 136.984C1.5488 135.127 0 132.563 0 129.736V10.2642C0 7.43864 1.54422 4.87175 4.03053 3.01237C6.51684 1.15413 9.95133 0 13.7334 0H103.948C107.727 0 111.16 1.15755 113.646 3.01465C116.135 4.87516 117.68 7.44548 117.68 10.2642V26.4893C117.68 28.4888 115.51 30.11 112.834 30.11C110.158 30.11 107.989 28.4888 107.989 26.4893V10.2642C107.989 9.44157 107.53 8.6862 106.792 8.13477C106.058 7.58561 105.048 7.24268 103.946 7.24268H13.7334C12.6267 7.24268 11.616 7.58447 10.8827 8.13363C10.1465 8.68164 9.69065 9.43701 9.69065 10.2642V129.736C9.69065 130.561 10.1495 131.314 10.8843 131.863C11.6221 132.414 12.6328 132.757 13.7334 132.757H103.948C105.045 132.757 106.053 132.413 106.791 131.862C107.53 131.31 107.991 130.556 107.991 129.736V113.51Z"
            fill="#152044"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="140" height="140" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span>Sair</span>
    </ButtonIcon>
  );
};
